export enum ProductTypeRenditionEnum {
  default = 'default',
  streamingBundle = 'streamingBundle',
  netflixStandalone = 'netflixStandalone',
  disneyStandalone = 'disneyStandalone'
}

export declare type productTypeRendition = ProductTypeRenditionEnum;
